import React, { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { LOGOS } from "../data/universities";

const links = [
  { to: "/", label: "Home" },
  { to: "/universita", label: "Università" },
  { to: "/corsi-di-laurea", label: "Corsi di Laurea" },
  { to: "/master", label: "Master" },
  { to: "/doppia-laurea", label: "Doppia Laurea" },
  { to: "/eventi", label: "Eventi" },
  { to: "/orientamento", label: "Orientamento" },
  { to: "/chi-siamo", label: "Chi Siamo" },
  { to: "/blog", label: "Blog" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  React.useEffect(() => setOpen(false), [location.pathname]);

  return (
    <header className="glass-nav fixed top-0 inset-x-0 z-50" data-testid="site-header">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 flex items-center gap-6 lg:gap-8 h-[84px]">
        <Link to="/" className="flex items-center gap-3 group shrink-0" data-testid="nav-logo">
          <img src={LOGOS.europa} alt="Istituto Europa Sassari" className="h-16 w-16 lg:h-[68px] lg:w-[68px] object-contain" />
          <div className="leading-tight whitespace-nowrap">
            <div className="font-heading font-extrabold text-brand-navy text-[15px] tracking-tight">ECP Profili</div>
            <div className="hidden xl:block text-[10px] uppercase tracking-[0.2em] text-brand-muted font-semibold">Istituto Europa · Sassari</div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center justify-center gap-5 xl:gap-6 flex-1 mx-auto">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className={({ isActive }) =>
                `text-[12.5px] xl:text-[13.5px] font-semibold whitespace-nowrap transition-colors ${
                  isActive ? "text-brand-emerald" : "text-brand-ink hover:text-brand-navy"
                }`
              }
              end={l.to === "/"}
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3 shrink-0">
          <a
            href="tel:+390792825126"
            className="hidden xl:inline-flex text-[13px] font-semibold text-brand-navy items-center gap-2 whitespace-nowrap hover:text-brand-emerald"
            data-testid="header-phone-link"
          >
            <Phone className="w-4 h-4" /> 079 282 5126
          </a>
          <Link to="/contatti" className="btn-primary text-sm whitespace-nowrap" data-testid="header-cta-button">
            Iscriviti Ora
          </Link>
        </div>

        <button
          className="lg:hidden ml-auto p-2 text-brand-navy"
          onClick={() => setOpen(!open)}
          aria-label="Apri menu"
          data-testid="mobile-menu-toggle"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-brand-line bg-white" data-testid="mobile-menu">
          <div className="px-5 py-4 flex flex-col gap-1">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                data-testid={`mobile-nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                className={({ isActive }) =>
                  `py-3 px-3 rounded-lg text-[15px] font-semibold ${
                    isActive ? "bg-brand-surface text-brand-emerald" : "text-brand-ink"
                  }`
                }
                end={l.to === "/"}
              >
                {l.label}
              </NavLink>
            ))}
            <Link to="/contatti" className="btn-primary justify-center mt-3" data-testid="mobile-cta-button">
              Iscriviti Ora
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
